import React from "react"
import {
  AboutSection,
  AboutHeadline,
  AboutParagraph,
  AboutWrapper,
  AboutBox,
} from "../../components/Container/styles"
import { Link } from "gatsby"
import Back from "../../components/Buttons/Back"
import { getLangFromPath } from "../../utils/index"

const Ziemia = ({ pageContext }) => {
  const location = getLangFromPath()
  return (
    <AboutWrapper>
      <AboutSection>
        <Link
          to={location === "en" ? "/en" : "/pl"}
          style={{ display: "contents" }}
        >
          <Back
            title={location === "en" ? " Back" : "Powrót"}
            en={location === "en"}
          />
        </Link>
        <AboutBox>
          <AboutHeadline>
            CONCEPT, SCRIPTING, RESEARCH AND AQUISITION OF AUDIOVISUAL MATERIALS
          </AboutHeadline>
          <AboutParagraph>
            Michał Czyżewski, Bartłomiej Makowski, Jacek Puciato, Szymon
            Antosik, Izabella Mazurek
          </AboutParagraph>
          
          <AboutHeadline>GRAPHIC DESIGN AND DEVELOPMENT TEAM</AboutHeadline>
          <AboutParagraph>
            Paweł Woźniak, Łukasz Haponiuk, Paula Karolak, Mateusz Orłowski,
            Michał Romańczuk, Rozalia Przeworska, Mariusz Łapiński, Alan
            Krawczyk, Marcin Kieruzel
          </AboutParagraph>
           <AboutHeadline>GAME DEVELOPMENT TEAM</AboutHeadline>
          <AboutParagraph>
            Łukasz Kowalski, Natalia Miętus, Rozalia Przeworska, Wojciech Florek
            (grafika)
          </AboutParagraph>
          <AboutHeadline>PROJECT COORDINATION</AboutHeadline>
          <AboutParagraph>Krzysztof Kossowski</AboutParagraph>
          <AboutHeadline>TECHNICAL COORDINATION</AboutHeadline>
          <AboutParagraph>Grzegorz Kowalski</AboutParagraph>
          <AboutHeadline>VIDEO</AboutHeadline>
          <AboutParagraph>
            Dział produkcji multimedialnych Polskiego Radia
          </AboutParagraph>
        </AboutBox>
        <AboutBox>
          <AboutHeadline>AUDIO MATERIALS SOURCES</AboutHeadline>
          <AboutParagraph>Archiwum Polskiego Radia</AboutParagraph>
          <AboutHeadline>PHOTO MATERIALS SOURCES</AboutHeadline>{" "}
          <AboutParagraph>
            Archiwum rodzinne Stanisława Lema © by Tomasz Lem, Narodowe Archiwum
            Cyfrowe, Polska Agencja Prasowa, Biblioteka Narodowa (Polona.pl),
            East News – agencja fotograficzna, Forum - Polska Agencja
            Fotografów, Archiwum Główne Akt Dawnych, Żydowski Instytut
            Historyczny im. Emanuela Ringelbluma, Repozytorium Cyfrowe
            Instytutów Naukowych PAN; NASA/Johns Hopkins University Applied
            Physics Laboratory/Southwest Research Institute; Shutterstock,
            Wydawnictwo Literackie <br />
            Specjalne podziękowania dla Pani Katarzyny Łozy.
          </AboutParagraph>
          <AboutHeadline>SOURCES</AboutHeadline>
          <AboutParagraph>
            Wojciech Orliński "Lem. Życie nie z tej ziemi", Wołowiec 2017;
            Agnieszka Gajewska "Zagłada i gwiazdy. Przeszłość w prozie
            Stanisława Lema", Poznań 2016; Tomasz Fijałkowski „Świat na
            krawędzi. Ze Stanisławem Lemem rozmawia Tomasz Fijałkowski”, Kraków
            2007; "Kalendarium życia i twórczości Stanisława Lema", oprac. Alina
            Doboszewska, w: Jerzy Jarzębski "Wszechświat Lema", Kraków 2003.
          </AboutParagraph>
          <AboutHeadline>TRANSLATION</AboutHeadline>
          <AboutParagraph>
            Barry Keane, Instytut Anglistyki Uniwersytetu Warszawskiego
          </AboutParagraph>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0"
            y="0"
            width={98.3 * 1.8}
            height={44.95 * 1.8}
            version="1.1"
            viewBox="0 0 393.2 179.8"
            xmlSpace="preserve"
          >
            <path
              fill={"#1C3A69"}
              d="M282.1 80.3c0 10.3-8.1 18.5-18.2 18.5s-18.1-8.2-18.1-18.5 8-18.5 18.1-18.5c10.1 0 18.2 8.3 18.2 18.5zm11-.1c0-8-3-15.4-8.6-21.1-5.5-5.7-12.5-8.6-20.7-8.6-8.1 0-15.1 2.9-20.7 8.6-5.5 5.7-8.6 13.1-8.6 21.1 0 8 3.1 15.6 8.6 21.1 5.5 5.6 12.7 8.6 20.7 8.6s15.1-3 20.7-8.6c5.5-5.7 8.6-13.1 8.6-21.1z"
              className="st0"
            ></path>
            <path
              fill={"#1C3A69"}
              d="M361.5 108.9L361.5 51.6 345.4 51.6 345.4 61.9 351.1 61.9 351.1 108.9 361.5 108.9z"
              className="st0"
            ></path>
            <path
              fill={"#1C3A69"}
              d="M336.6 68.9c0-9.9-8.1-18.4-18.4-18.4-9.9 0-16.8 6.5-18.4 18H311c.9-5 3.6-7.6 7.8-7.6 4 0 6.7 2.8 6.7 6.8 0 3.1-1.9 5.9-4.5 9.7l-21.2 31.5h35V98.1h-14.3l10.6-15.8c3.2-4.8 5.5-8.6 5.5-13.4zM226.9 68.9c0-9.9-8.1-18.4-18.3-18.4-10 0-16.9 6.5-18.4 18h11.2c1-5 3.7-7.6 7.8-7.6 3.9 0 6.6 2.8 6.6 6.8 0 3.1-1.8 5.9-4.4 9.7l-21.2 31.5h35V98.1h-14.3l10.7-15.8c3.1-4.8 5.3-8.6 5.3-13.4z"
              className="st0"
            ></path>
            <path
              fill={"#1C3A69"}
              d="M157.1 108.9L146.4 50.5 127.3 89 107.8 50.5 98.2 108.9 109.8 108.9 113.2 83.9 127.6 110.9 141.7 83.9 145.1 108.9 157.1 108.9z"
              className="st0"
            ></path>
            <path
              fill={"#1C3A69"}
              d="M90.7 108.9L90.7 97.3 76.4 97.3 76.4 86.2 90.7 86.2 90.7 75.2 76.4 75.2 76.4 62.5 90.7 62.5 90.7 51.6 64.3 51.6 64.3 108.9 90.7 108.9z"
              className="st0"
            ></path>
            <path
              fill={"#1C3A69"}
              d="M58 108.9L58 97.5 43.1 97.5 43.1 51.6 31.2 51.6 31.2 108.9 58 108.9z"
              className="st0"
            ></path>
            <path
              fill={"#1C3A69"}
              d="M170.7 62.2c-1.2 0-3.2.4-4.4 1.3 0 0-1.7-8.4-.7-21.7.9-13.4 4.8-25 5.1-26.1.4 1.1 4.2 12.7 5.1 26.1.9 13.3-.7 21.7-.7 21.7-1.2-.9-3.2-1.3-4.4-1.3zM162.9 48.6c-.4-.9-1.1-3.2-1.6-4-.5-.8-1.2.9-1.8 3.7-1.7 7.7-2.9 20 .4 27.3.5 1 .8.8.8.8.4-2.4.6-7.3 3.3-12.1-1.1-8.8-1.2-12-1.1-15.7zM178.5 48.6c.4-.9 1.1-3.2 1.6-4 .5-.8 1.2.9 1.8 3.7 1.7 7.7 2.9 20-.4 27.3-.5 1-.8.8-.8.8-.4-2.4-.6-7.3-3.3-12.1 1.1-8.8 1.2-12 1.1-15.7zM170.7 110c.8-2.4 2.2-39.7 2.2-42 0-2.3-2.2-2.7-2.2-2.7s-2.2.4-2.2 2.7c0 2.3 1.4 39.6 2.2 42z"
              className="st0"
            ></path>
            <path
              fill={"#1C3A69"}
              d="M34.2 126.2h-3.5l1.7-2.9h4.9v20.4h-3.1v-17.5zM43.1 133.4c0-3.2.8-5.8 2.3-7.8 1.4-1.7 3-2.6 4.9-2.6s3.6.9 4.9 2.6c1.5 1.9 2.3 4.6 2.3 7.9 0 3.3-.8 6-2.3 7.9-1.4 1.7-3 2.6-4.9 2.6s-3.6-.9-4.9-2.6c-1.6-2-2.3-4.6-2.3-8zm3 0c0 2.3.4 4.1 1.2 5.6.8 1.5 1.8 2.2 3 2.2s2.2-.7 3-2.2c.8-1.5 1.2-3.3 1.2-5.5s-.4-4.1-1.2-5.5c-.8-1.5-1.8-2.2-3-2.2s-2.2.7-3 2.2c-.8 1.4-1.2 3.2-1.2 5.4zM59.8 133.4c0-3.2.8-5.8 2.3-7.8 1.4-1.7 3-2.6 4.9-2.6s3.6.9 4.9 2.6c1.5 1.9 2.3 4.6 2.3 7.9 0 3.3-.8 6-2.3 7.9-1.4 1.7-3 2.6-4.9 2.6s-3.6-.9-4.9-2.6c-1.6-2-2.3-4.6-2.3-8zm3 0c0 2.3.4 4.1 1.2 5.6.8 1.5 1.8 2.2 3 2.2s2.2-.7 3-2.2c.8-1.5 1.2-3.3 1.2-5.5s-.4-4.1-1.2-5.5c-.8-1.5-1.8-2.2-3-2.2s-2.2.7-3 2.2c-.8 1.4-1.2 3.2-1.2 5.4zM92.9 135l6.3 8.7h-3.8l-5.8-8.3H89v8.3h-3v-20.4h3.6c2.7 0 4.6.5 5.8 1.5 1.3 1.1 2 2.6 2 4.5 0 1.4-.4 2.7-1.2 3.7-.8 1-1.9 1.7-3.3 2zm-3.8-2.3h1c2.9 0 4.4-1.1 4.4-3.3 0-2.1-1.4-3.1-4.2-3.1h-1.1v6.4zM100.8 133.4c0-2.9 1.1-5.3 3.2-7.4 2.1-2.1 4.6-3.1 7.5-3.1 2.9 0 5.4 1 7.5 3.1 2.1 2.1 3.1 4.6 3.1 7.5 0 2.9-1 5.4-3.1 7.4s-4.6 3.1-7.6 3.1c-2.6 0-5-.9-7.1-2.7-2.3-2-3.5-4.6-3.5-7.9zm3.1 0c0 2.2.8 4.1 2.3 5.6 1.5 1.4 3.2 2.2 5.2 2.2 2.1 0 3.9-.7 5.4-2.2 1.5-1.5 2.2-3.3 2.2-5.5s-.7-4-2.2-5.5c-1.4-1.5-3.2-2.2-5.4-2.2-2.1 0-3.9.7-5.4 2.2-1.3 1.5-2.1 3.3-2.1 5.4zM141 124.4v3.6c-1.8-1.5-3.6-2.2-5.5-2.2-2.1 0-3.9.8-5.3 2.3-1.4 1.5-2.2 3.3-2.2 5.5 0 2.1.7 3.9 2.2 5.4 1.4 1.5 3.2 2.2 5.3 2.2 1.1 0 2-.2 2.8-.5.4-.2.9-.4 1.3-.7.5-.3.9-.7 1.4-1.1v3.7c-1.8 1-3.6 1.5-5.5 1.5-2.9 0-5.4-1-7.4-3s-3.1-4.5-3.1-7.4c0-2.6.9-4.9 2.6-6.9 2.1-2.5 4.8-3.7 8.2-3.7 1.7-.2 3.5.3 5.2 1.3zM148.4 140.8h9.8v2.9h-14.8l10-17.5H145v-2.9h13.4l-10 17.5zM161.8 143.7V122l14.8 15.5v-14.1h3.1V145l-14.8-15.5v14.3h-3.1zM187.6 123.3v20.4h-3.1v-20.4h3.1zM207.6 124.4v3.6c-1.8-1.5-3.6-2.2-5.5-2.2-2.1 0-3.9.8-5.3 2.3-1.4 1.5-2.2 3.3-2.2 5.5 0 2.1.7 3.9 2.2 5.4 1.4 1.5 3.2 2.2 5.3 2.2 1.1 0 2-.2 2.8-.5.4-.2.9-.4 1.3-.7.5-.3.9-.7 1.4-1.1v3.7c-1.8 1-3.6 1.5-5.5 1.5-2.9 0-5.4-1-7.4-3s-3.1-4.5-3.1-7.4c0-2.6.9-4.9 2.6-6.9 2.1-2.5 4.8-3.7 8.2-3.7 1.7-.2 3.5.3 5.2 1.3zM223.9 138.7h-8.7l-2.3 4.9h-3.3l10.1-21.6 9.7 21.6H226l-2.1-4.9zm-1.3-2.9l-3-6.9-3.2 6.9h6.2zM243.3 123.3v12.3c0 1.7.3 3 .9 3.8.9 1.2 2.1 1.8 3.6 1.8 1.6 0 2.8-.6 3.6-1.8.6-.8.9-2.1.9-3.8v-12.3h3.1v13.1c0 2.1-.7 3.9-2 5.3-1.5 1.5-3.3 2.3-5.5 2.3s-4-.8-5.5-2.3c-1.3-1.4-2-3.2-2-5.3v-13.1h2.9zM267.1 135l6.3 8.7h-3.8l-5.8-8.3h-.6v8.3h-3.1v-20.4h3.6c2.7 0 4.6.5 5.8 1.5 1.3 1.1 2 2.6 2 4.5 0 1.4-.4 2.7-1.2 3.7-.8 1-1.9 1.7-3.2 2zm-3.8-2.3h1c2.9 0 4.4-1.1 4.4-3.3 0-2.1-1.4-3.1-4.2-3.1h-1.1v6.4zM275 133.4c0-2.9 1-5.3 3.2-7.4 2.1-2.1 4.6-3.1 7.5-3.1 2.9 0 5.4 1 7.5 3.1 2.1 2.1 3.1 4.6 3.1 7.5 0 2.9-1 5.4-3.1 7.4s-4.6 3.1-7.6 3.1c-2.6 0-5-.9-7.1-2.7-2.4-2-3.5-4.6-3.5-7.9zm3.1 0c0 2.2.8 4.1 2.3 5.6 1.5 1.4 3.2 2.2 5.2 2.2 2.1 0 3.9-.7 5.4-2.2 1.5-1.5 2.2-3.3 2.2-5.5s-.7-4-2.2-5.5c-1.4-1.5-3.2-2.2-5.4-2.2-2.1 0-3.9.7-5.4 2.2-1.4 1.5-2.1 3.3-2.1 5.4zM300.1 143.7v-20.4h4.3c2 0 3.7.2 4.9.6 1.3.4 2.4 1.1 3.5 2 2.1 1.9 3.2 4.4 3.2 7.6 0 3.1-1.1 5.7-3.3 7.6-1.1 1-2.2 1.6-3.5 2-1.1.4-2.7.6-4.8.6h-4.3zm3.1-2.9h1.4c1.4 0 2.5-.1 3.4-.4.9-.3 1.7-.8 2.5-1.5 1.5-1.4 2.3-3.2 2.3-5.4s-.7-4-2.2-5.4c-1.3-1.2-3.3-1.9-5.9-1.9h-1.4v14.6zM323.2 140.8h9.8v2.9h-14.8l10-17.5h-8.4v-2.9h13.4l-10 17.5zM339.7 123.3v20.4h-3.1v-20.4h3.1zM344.6 143.7V122l14.8 15.5v-14.1h3.1V145l-14.8-15.5v14.3h-3.1z"
              className="st1"
            ></path>
          </svg>
        </AboutBox>
      </AboutSection>
    </AboutWrapper>
  )
}

export default Ziemia
